var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.isTablet && 'tablet'],attrs:{"id":"app"}},[_c('v-app',{attrs:{"id":"vuetify-app"}},[_c(_vm.layout,{tag:"component"},[_c('router-view')],1),_c('error-dialog'),_c('loading-dialog'),_c('email-address-dialog'),_c('reset-password-dialog')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }